module.exports = __webpack_public_path__ + "static/city_step01-3df1631c15847c276269a37be38f0296.png";